import images from "@assets/images";
import Icon from "@expo/vector-icons/MaterialIcons";
import { CommonActions, useNavigation, useRoute } from "@react-navigation/native";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectAuthLoggedIn } from "@src/ducks/slices/auth.slice";
import { ImageButton } from "components/button";
import React from "react";
import { Image, Text, View } from "react-native";
import { Scale } from "utils/animation";
import useStyles from "./styles.css";

const ApcopayResult = () => {
  const styles = useStyles();
  const route = useRoute<any>();
  const status = route.params?.status;
  const isSuccess = status === "success";
  const navigation = useNavigation<any>();
  const isLoggedIn = useAppSelector(selectAuthLoggedIn);
  const label = isSuccess ? "PAYMENT SUCCESSFUL\nThank you" : "PAYMENT ERROR!";

  const onClose = () => {
    navigation.dispatch(
      CommonActions.reset({
        index: 1,
        routes: [
          { name: isLoggedIn ? "Home" : "SignInOption" },
        ],
      })
    );
  };

  return (
    <View style={styles.container}>
      <Scale style={styles.container}>
        <View style={styles.center_view}>
          <View style={styles.v_top}>
            <Image style={styles.image_logo} 
              source={{uri: images["apcopay-logo"]}} resizeMode="contain" />
          </View>
          <View style={styles.v_bottom}>
            <Text style={styles.t_label}>{label}</Text>
            <View style={styles.v_circle}>
              <Icon name={isSuccess ? "check" : "close"} color={isSuccess ? "white" : "red"} size={80} />
            </View>
          </View>
          <ImageButton
            onPress={onClose}
            style={styles.btn_close}
            source={{uri: images["btn-close-red"]}}
          />
        </View>
      </Scale>
    </View>
  );
};

export default ApcopayResult;
